module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "forewordPage"
  }, [_c('div', {
    staticClass: "title-forewordPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Foreword")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("E")]), _vm._v("veryone says, “I wish I had my own bakery or specialty food store.” Sounds like fun, doesn’t it? You hang out in the kitchen and test a fabulous chocolate cake. You travel to Milan to see what’s new in food. Maybe you drop into the store on Saturdays to have a cup of coffee and chat with the customers. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Not exactly!")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Kathleen King opened Tate’s Bake Shop in Southampton, New York, just a year or two after I opened Barefoot Contessa in nearby Westhampton Beach. I wish I could say that we spent a lot of time together in those early years, but, instead, we were each working twenty-hour days, seven days a week. I know it was as much fun for Kathleen as it was for me, but it was also an amazing amount of hard work. Kathleen is totally hands-on and she’s a bundle of energy. When she decides to make lemon bars, she tests the recipe over and over again until it’s "), _c('em', {
    staticClass: "i"
  }, [_vm._v("absolutely")]), _vm._v(" perfect, and then she sees it all the way through large-scale production. Almost anyone can make twelve really good lemon bars. Kathleen knows how to make twelve thousand really good lemon bars—and, believe me, that’s not easy.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("As soon as Kathleen opened her doors in 1980, Barefoot Contessa carried everything she made: chocolate chip cookies, oatmeal cookies, lemon bread, carrot cakes, sour cream coffee cakes … even the most delicious doughnut holes. Every day we placed an enormous order and every night the shelves were empty.\nThese weren’t just any chocolate chip cookies; they were the best chocolate chip cookies you ever ate. Over the past twenty-five years, Kathleen has developed an amazing line of baked goods—from moist blueberry muffins, to delicious raspberry squares, to her famous carrot cake with cream cheese icing. Sure, you could get in your car and drive all the way to Southampton to pick up a bag of goodies, but Kathleen has shared her secrets in this book, so now you can make all of her famous baked goods right at home. Start with the chocolate chip cookies.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-d"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("—Ina Garten")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44b1e41b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466815902_frw01.vue
// module id = 66
// module chunks = 0